import { render, staticRenderFns } from "./DetailsEn.vue?vue&type=template&id=d9c41188&scoped=true&"
import script from "./DetailsEn.vue?vue&type=script&lang=js&"
export * from "./DetailsEn.vue?vue&type=script&lang=js&"
import style0 from "./DetailsEn.vue?vue&type=style&index=0&id=d9c41188&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c41188",
  null
  
)

export default component.exports